<template>
  <div
      id="section2"
      class="section col_w_3"
  >
    <div class="section_wrap">
      <div class="ad_script_container">
        <div class="ad_script_box">
          <h4 class="mt20 mb20">
            rebless™ Clinic <br/>
            offers online services to healthcare providers.
          </h4>
          <p class="txt_body_1">
            Our platform allows healthcare professionals to treat patients <br/>
            at a distance using telecommunications technology.
          </p>
        </div>
        <div class="ad_button">
          <router-link
              to="/payments"
              class="btn blue btn_basics btn_fit no-drag"
          >
            Start rebless™ Clinic
          </router-link>
        </div>
      </div>
      <div class="ad_img">
        <img
            :src="`/images/paymentAd/bg-mockup-img-${lang}.png`"
            alt=""
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PaymentAd',
  data() {
    return {
      lang: localStorage.getItem('lang') ?? 'en'
    }
  }
}
</script>
<style lang="scss">
#section2 {
  background-image: url("/images/paymentAd/bg-pattern02.png");
  background-size: contain;
  background-color: var(--white);
  background-position-x: 220px;
  background-repeat: no-repeat;
  height: 100%;

  .section_wrap {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .ad_script_container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .ad_button {
    margin: 20px 0;
  }

  .ad_img {
    width: 50%;
    height: 290px;

    img {
      position: absolute;
      max-width: 45%;
      bottom: -30px;
    }
  }
}
</style>